import React from "react";

import Button from "../Button";
import Icon from "../Icon";
import InlineLink from "../InlineLink";
import TextField from "../TextField";
import addSubscriber from "../../helpers/addSubscriber";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import useEvent from "../../hooks/useEvent";
import { useForm } from "react-hook-form";

type Inputs = {
  email: string;
};

export interface SubscriptionFormProps {
  title?: string;
  buttonName?: string;
}

const SubscriptionForm = ({
  title = "Subscribe to our newsletters.",
  buttonName = "Subscribe",
}: SubscriptionFormProps) => {
  const event = useEvent();
  const { register, handleSubmit, errors, formState } = useForm<Inputs>({
    mode: "onChange",
  });

  const onSubmit = (data: Inputs) => {
    addSubscriber(data.email);
  };

  return (
    <>
      <div className="text-lg font-medium text-aqua">{title}</div>
      <div className="my-2">
        <form className="flex" onSubmit={handleSubmit(onSubmit)}>
          <TextField
            type="email"
            name="email"
            placeholder="Email Address"
            register={register({
              required: "Required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z0-9]{2,}$/i,
                message: "Invalid email address.",
              },
            })}
            error={errors.email?.message}
          />
          <div className="ml-4">
            <Button
              type="submit"
              disabled={!formState.isValid}
              isLoading={formState.isSubmitting}
            >
              {buttonName}
            </Button>
          </div>
        </form>
        {formState.isSubmitted ? (
          <div className="w-full my-2 text-sm text-green-600">
            <Icon icon={faCheck} /> Subscribed successfully.
          </div>
        ) : null}
      </div>
      <div className="mt-4 text-xs text-gray-400">
        You can unsubscribe at any time.{" "}
        <InlineLink to={`/${event}/privacy`}>
          Read our privacy policy
        </InlineLink>
      </div>
    </>
  );
};

export default SubscriptionForm;
